import { Typography } from '@zenlink-interface/ui'
import type { FC } from 'react'
import React from 'react'

const Icon = ({ fill = '#6BDF9E', ...other }: React.ComponentProps<'svg'>) => {
  return (
    <svg viewBox="0 0 370 314" {...other}>
      <defs>
        <linearGradient
          x1="100%"
          y1="45.665%"
          x2="2.189%"
          y2="45.07%"
          id="a"
        >
          <stop stopColor="#161D1E" stopOpacity="0" offset="0%" />
          <stop stopColor="#008EF3" stopOpacity="0.3" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="100%"
          y1="45.434%"
          x2="1.651%"
          y2="44.804%"
          id="b"
        >
          <stop stopColor="#161D1E" stopOpacity="0" offset="0%" />
          <stop stopColor="#F20082" stopOpacity="0.3" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="99.368%"
          id="c"
        >
          <stop stopColor="#8100E1" offset="0%" />
          <stop stopColor="#008EF3" offset="40.548%" />
          <stop stopColor="#00CCD5" offset="62.665%" />
          <stop stopColor="#F2B082" offset="74.527%" />
          <stop stopColor="#F20082" offset="100%" />
        </linearGradient>
        <linearGradient
          x1="-50.019%"
          y1="24.763%"
          x2="107.67%"
          y2="24.763%"
          id="d"
        >
          <stop stopColor="#8100E1" offset="0%" />
          <stop stopColor="#008EF3" offset="40.548%" />
          <stop stopColor="#00CCD5" offset="62.665%" />
          <stop stopColor="#F2B082" offset="74.527%" />
          <stop stopColor="#F20082" offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path
          d="M309 134.076v12.958a4.966 4.966 0 0 1-4.966 4.966H122.8c-5.965 0-10.8-4.835-10.8-10.8V10.8C112 4.835 116.835 0 122.8 0h181.409A4.791 4.791 0 0 1 309 4.791v13.921"
          strokeOpacity="0.4"
          stroke="#008EF3"
          strokeWidth="0.9"
          fill="url(#a)"
          transform="translate(0 1)"
        />
        <path
          d="M141.046 18.42v6.114c0 .738.111 1.298.334 1.68.223.382.664.573 1.326.573.66 0 1.103-.18 1.325-.543.223-.362.334-.932.334-1.71V18.42h2.51v6.235c0 1.448-.344 2.535-1.032 3.259-.688.724-1.734 1.086-3.137 1.086-2.78 0-4.17-1.448-4.17-4.345V18.42h2.51Zm11.617-.121c.783 0 1.474.13 2.075.392.6.262 1.066.624 1.396 1.086.33.463.496.983.496 1.56v.12h-2.327v-.06a.97.97 0 0 0-.435-.845c-.29-.201-.692-.302-1.205-.302-.512 0-.904.1-1.174.302a.954.954 0 0 0-.404.804c0 .309.104.55.313.724.21.175.55.295 1.022.363l1.235.18c1.052.148 1.842.47 2.368.966.526.496.79 1.18.79 2.052 0 1.073-.392 1.9-1.175 2.484-.782.583-1.8.875-3.056.875-1.2 0-2.165-.292-2.894-.875-.728-.583-1.093-1.364-1.093-2.343v-.08h2.348v.04c0 .388.159.693.476.915.317.22.732.332 1.244.332.553 0 .985-.098 1.296-.292.31-.195.465-.486.465-.875 0-.322-.115-.57-.344-.744-.23-.175-.614-.302-1.154-.383l-1.113-.18c-1.052-.175-1.828-.497-2.327-.966-.5-.47-.75-1.14-.75-2.012 0-.992.369-1.78 1.104-2.363.735-.583 1.676-.875 2.823-.875Zm9.695 0c1.336 0 2.361.312 3.076.935.715.624 1.073 1.546 1.073 2.766v6.88h-2.429v-.906c-.35.362-.712.624-1.083.785-.37.16-.84.241-1.406.241-1.08 0-1.916-.288-2.51-.865-.594-.577-.89-1.374-.89-2.394 0-.938.317-1.68.95-2.222.635-.543 1.519-.815 2.652-.815h2.226v-.825c0-1.113-.56-1.67-1.68-1.67-.472 0-.846.118-1.123.353-.276.234-.415.546-.415.935v.06h-2.327v-.08c0-.979.35-1.753 1.052-2.323.702-.57 1.647-.855 2.834-.855Zm26.493 0c1.336 0 2.361.312 3.076.935.715.624 1.073 1.546 1.073 2.766v6.88h-2.429v-.906c-.35.362-.711.624-1.083.785-.37.16-.84.241-1.406.241-1.08 0-1.916-.288-2.51-.865-.593-.577-.89-1.374-.89-2.394 0-.938.317-1.68.95-2.222.635-.543 1.519-.815 2.652-.815h2.227v-.825c0-1.113-.56-1.67-1.68-1.67-.473 0-.847.118-1.124.353-.276.234-.414.546-.414.935v.06h-2.328v-.08c0-.979.35-1.753 1.052-2.323.702-.57 1.647-.855 2.834-.855ZM129.651 15v6.477L134.488 15h3.178l-4.473 5.572 4.837 8.307h-3.076l-3.46-6.175-1.843 2.293v3.882H127V15h2.651Zm49.647 3.299c1.12 0 1.994.335 2.621 1.006.627.67.941 1.589.941 2.755v6.82h-2.51v-6.518c0-.603-.151-1.063-.455-1.378-.303-.315-.698-.473-1.184-.473-.513 0-.92.165-1.224.493-.304.329-.456.761-.456 1.298v6.577h-2.51v-6.517c0-.603-.151-1.063-.455-1.378-.303-.315-.698-.473-1.184-.473-.499 0-.904.161-1.214.483-.31.322-.466.778-.466 1.368v6.517h-2.51V18.42h2.45v.946c.31-.335.684-.597 1.123-.785a3.437 3.437 0 0 1 1.366-.281c1.174 0 2.071.436 2.692 1.307.81-.871 1.801-1.307 2.975-1.307Zm-15.28 6.115h-1.822c-1.052 0-1.579.422-1.579 1.267 0 .872.513 1.308 1.538 1.308.662 0 1.137-.151 1.427-.453.29-.302.435-.761.435-1.378v-.744Zm26.493 0h-1.822c-1.052 0-1.579.422-1.579 1.267 0 .872.513 1.308 1.539 1.308.66 0 1.136-.151 1.426-.453.29-.302.436-.761.436-1.378v-.744Z"
          fillOpacity="0.246"
          fill="#5FC3E4"
        />
        <path
          d="M309 306.377a5.623 5.623 0 0 1-5.623 5.623H122.8c-5.965 0-10.8-4.835-10.8-10.8V166.8c0-5.965 4.835-10.8 10.8-10.8h180.775a5.425 5.425 0 0 1 5.425 5.425"
          strokeOpacity="0.466"
          stroke="#F20082"
          strokeWidth="0.9"
          fill="url(#b)"
          transform="translate(0 1)"
        />
        <path
          d="M183.362 285v13.88h-2.47v-.966c-.585.724-1.415 1.086-2.49 1.086-1.02 0-1.861-.359-2.521-1.076-.66-.718-.99-1.8-.99-3.249v-2.072c0-1.448.323-2.527.97-3.238.646-.71 1.486-1.066 2.52-1.066 1.062 0 1.885.395 2.47 1.187V285h2.511Zm-40.766 3.299c1.32 0 2.361.355 3.123 1.066.763.71 1.144 1.81 1.144 3.299v1.95c0 1.503-.381 2.61-1.144 3.32-.762.71-1.803 1.066-3.123 1.066-1.334 0-2.385-.355-3.154-1.066-.769-.71-1.153-1.817-1.153-3.32v-1.95c0-1.489.384-2.588 1.153-3.3.77-.71 1.82-1.065 3.154-1.065Zm26.089 0c1.347 0 2.382.312 3.103.935.721.624 1.082 1.546 1.082 2.766v6.88h-2.45v-.906c-.354.362-.718.624-1.092.785-.374.16-.847.241-1.419.241-1.088 0-1.932-.288-2.531-.865-.599-.577-.898-1.374-.898-2.394 0-.938.32-1.68.96-2.222.639-.543 1.53-.815 2.673-.815h2.246v-.825c0-1.113-.565-1.67-1.694-1.67-.477 0-.854.118-1.133.353-.28.234-.419.546-.419.935v.06h-2.347v-.08c0-.979.353-1.753 1.061-2.323.708-.57 1.66-.855 2.858-.855Zm21.006 0c1.32 0 2.361.355 3.123 1.066.762.71 1.143 1.81 1.143 3.299v1.95c0 1.503-.38 2.61-1.143 3.32-.762.71-1.803 1.066-3.123 1.066-1.334 0-2.385-.355-3.154-1.066-.77-.71-1.154-1.817-1.154-3.32v-1.95c0-1.489.385-2.588 1.154-3.3.769-.71 1.82-1.065 3.154-1.065ZM132.267 285c1.429 0 2.555.389 3.378 1.167.824.777 1.235 1.844 1.235 3.198 0 1.287-.411 2.317-1.235 3.088-.823.77-1.95 1.156-3.378 1.156h-2.593v5.27H127V285h5.267Zm19.148 0v10.54c0 .43.078.734.235.915.156.181.411.272.765.272h.858v2.152h-1.164c-1.02 0-1.813-.275-2.378-.824-.565-.55-.847-1.335-.847-2.354V285h2.53Zm5.859 0v7.764l3.43-4.344h3l-3.634 4.163 3.9 6.296h-3.063l-2.51-4.385-1.123 1.288v3.097h-2.532V285h2.532Zm41.685.503v2.917H201v1.75h-2.041v5.531c0 .71.347 1.066 1.04 1.066h.797v2.112h-1.205c-.966 0-1.731-.271-2.296-.814-.565-.543-.847-1.278-.847-2.203v-5.692h-1.47v-1.75h1.47v-2.052l2.51-.865Zm-28.6 8.91h-1.837c-1.062 0-1.593.423-1.593 1.268 0 .872.518 1.308 1.552 1.308.667 0 1.146-.151 1.439-.453.293-.302.439-.761.439-1.378v-.744Zm-27.763-3.902c-1.197 0-1.796.731-1.796 2.193v1.89c0 1.463.599 2.193 1.796 2.193 1.17 0 1.756-.73 1.756-2.192v-1.891c0-1.462-.585-2.193-1.756-2.193Zm36.52 0c-1.13 0-1.694.731-1.694 2.193v1.89c0 1.463.544 2.193 1.633 2.193.572 0 1.014-.187 1.327-.563.313-.375.47-.918.47-1.63v-1.89c0-.71-.154-1.254-.46-1.63-.306-.375-.731-.563-1.276-.563Zm10.575 0c-1.198 0-1.797.731-1.797 2.193v1.89c0 1.463.6 2.193 1.797 2.193 1.17 0 1.755-.73 1.755-2.192v-1.891c0-1.462-.585-2.193-1.755-2.193Zm-57.547-3.218h-2.47v4.003h2.47c.64 0 1.143-.168 1.51-.503.368-.335.552-.811.552-1.428 0-.67-.18-1.183-.54-1.539-.362-.355-.868-.533-1.522-.533Z"
          fillOpacity="0.4"
          fill="#F20082"
        />
        <path
          d="M0 111.5C0 173.08 49.921 223 111.5 223c61.58 0 111.5-49.92 111.5-111.5S173.08 0 111.5 0C49.922 0 0 49.92 0 111.5"
          fill="url(#c)"
          transform="translate(0 42)"
        />
        <path
          d="M1 153.5C1 214.527 50.473 264 111.5 264c61.028 0 110.5-49.473 110.5-110.5S172.528 43 111.5 43C50.474 43 1 92.473 1 153.5"
          fill="#161D1E"
        />
        <path
          d="m29.731 95 81.328 60.267H212C210.837 209.44 166.292 253 111.512 253 56 253 11 208.271 11 153.095 11 131.427 17.94 111.37 29.731 95Z"
          fill="#FF1995"
        />
        <path
          d="M111.424 53c54.896 0 99.502 44.016 100.39 98.65v.35h-99.683L31.815 92.177C50.172 68.352 79.003 53 111.424 53Z"
          fill="#01A3EE"
        />
        <path
          d="M112.003 212C80.02 212 54 185.982 54 154s26.02-58 58.003-58c31.984 0 58.004 26.018 58.004 58s-26.02 58-58.004 58"
          fill="#11131A"
        />
        <text
          fontFamily="PingFangSC-Light, PingFang SC"
          fontSize="11.34"
          fontWeight="300"
          letterSpacing="0.283"
          fill="#EDEFF2"
          transform="translate(0 1)"
        >
          <tspan x="78" y="141">
            Total Supply
          </tspan>
        </text>
        <text
          fill="url(#d)"
          fillRule="nonzero"
          fontFamily="Manix-SansHL-Bold, Manix Sans HL"
          fontSize="14"
          fontWeight="bold"
          letterSpacing="0.35"
          transform="translate(0 1)"
        >
          <tspan x="70" y="165">
            100,000,000
          </tspan>
        </text>
        <path
          d="M306.896 294.987C274.69 293.623 249 267.073 249 234.52c0-33.424 27.087-60.52 60.5-60.52s60.5 27.096 60.5 60.521c0 9.93-2.39 19.3-6.627 27.568l-56.301-31.454-.176 64.352Z"
          fill="#F32FE1"
        />
        <path
          d="m311.775 295 .153-56.061 49.046 27.4c-10.29 16.624-28.404 27.892-49.199 28.661Z"
          fill="#975CF5"
        />
        <path
          d="M269 77.036C269 54.925 286.925 37 309.036 37c21.298 0 38.712 16.63 39.964 37.614h-42.386V117C285.63 115.748 269 98.334 269 77.036Z"
          fill="#0FCED6"
        />
        <path
          d="M311.458 117V79.458H349c-1.204 20.182-17.36 36.338-37.542 37.542Z"
          fill={fill}
        />
      </g>
    </svg>
  )
}

export default Icon

interface RateDescProps {
  color: string
  desc?: string
  className?: string
  title: string
}

export const RateDesc: FC<RateDescProps> = ({ className, color, desc, title }) => {
  return (
    <div className={className}>
      <div className="flex items-center">
        <span className="w-1.5 h-1.5 rounded mr-2" style={{ backgroundColor: color }} />
        <Typography className="text-slate-700 dark:text-slate-300">{title}</Typography>
        {desc && <Typography weight={500} className="text-black dark:text-white">: {desc}</Typography>}
      </div>
    </div>
  )
}
